import { OptionData } from '../../model/OptionData';
import Select from './Select';

interface FiltroProps {
  nombre: string;
  margin?: string[];
  width?: string[];
  maxWidth?: string[];
  opciones?: OptionData[];
  onChange(value: string): void;
  defaultValue?: string;
}

export const Filtro = (props: FiltroProps) => {
  const handleChange = (event: { target: { value: string } }) => {
    props.onChange(event.target.value);
  };
  return (
    <>
      <Select
        margin={props.margin}
        width={props.width}
        maxWidth={props.maxWidth}
        defaultValue={props.defaultValue ?? '-1'}
        onChange={handleChange}
      >
        <option value="-1" disabled>
          {props.nombre}
        </option>
        {props?.opciones?.map((opcion, index) => (
          <option key={index} value={opcion.value} aria-label={opcion.ariaLabel}>
            {opcion.label}
          </option>
        ))}
      </Select>
    </>
  );
};
